<template>
    <div class="price-selector">
        <h1 class="selected-amount">${{ amountNum }}</h1>
        <slot name="sub-header"></slot>
        <div class="selector-input-wrapper">
            <div class="selector-input-row">
                <div class="number-input" @click="addNumber('1')">1</div>
                <div class="number-input" @click="addNumber('2')">2</div>
                <div class="number-input" @click="addNumber('3')">3</div>
            </div>

            <div class="selector-input-row">
                <div class="number-input" @click="addNumber('4')">4</div>
                <div class="number-input" @click="addNumber('5')">5</div>
                <div class="number-input" @click="addNumber('6')">6</div>
            </div>

            <div class="selector-input-row">
                <div class="number-input" @click="addNumber('7')">7</div>
                <div class="number-input" @click="addNumber('8')">8</div>
                <div class="number-input" @click="addNumber('9')">9</div>
            </div>

            <div class="selector-input-row">
                <div class="number-input"></div>
                <div class="number-input" @click="addNumber('0')">0</div>
                <div class="number-input" @click="removeNumber()"><</div>
            </div>
        </div>
        <p v-if="error" class="gift-error-msg">{{ error }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            defaultAmountDollar: {
                type: Number,
                default: 0
            },
            amount: Number,
            maxAmountCents: {
                type: Number,
                default: 100000 // Cents
            }
        },
        data: function () {
            return {
                amountStr: '',
                error: undefined
            }
        },
        methods: {
            addNumber(numberStr) {
               this.amountStr += numberStr;
            },
            removeNumber() {
                this.error = '';
                if (this.amountStr.length) {
                    this.amountStr = this.amountStr.slice(0, -1);
                }
            },
            checkMaxAmount() {
                if (this.amountNum > this.maxAmount) {
                    this.amountStr = (this.maxAmount).toString();
                    this.error = `Maximum amount is $${this.maxAmount}.`
                }
            },
            validate() {
                if (this.amount <= 0) {
                    this.error = 'Please enter gift amount.';
                    return false;
                } else if (this.amount > this.maxAmountCents) {
                    this.error = 'Gift amount is not valid.';
                    return false;
                }
                return true;
            }
        },
        computed: {
            maxAmount: function() {
                return this.maxAmountCents * 0.01;
            },
            amountNum: function() {
                if (this.amountStr.length < 1) {
                    return 0;
                }

                return parseInt(this.amountStr);
            }
        },
        watch: {
            amountNum: function() {
                this.checkMaxAmount();
                // Convert to cents
                this.$emit('update:amount', this.amountNum * 100);
            },
            maxAmountCents: function() {
                this.error = undefined;
                this.checkMaxAmount();
            }
        },
        mounted() {
            this.amountStr = this.defaultAmountDollar.toString();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/variables_home";
    @import "../../styles/common_home";

    .selected-amount {
        font-size: 80px;
        line-height: 80px;
    }
    .selector-input-wrapper {
        max-width: 400px;
        margin: 2rem auto;
    }
    .selector-input-row {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }
    .number-input {
        width: 100px;
        height: 80px;
        font-weight: bold;
        font-size: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        &:hover {
            color: darken($color-primary, 15%);
        }
        &:active {
            font-size: 50px;
        }
    }
    .gift-error-msg {
        color: $red-light;
    }

    @media only screen and (max-width: $max-mobile-width) {
        .selected-amount {
            font-size: 60px;
            line-height: 60px;
        }
        .number-input {
            width: 64px;
            height: 64px;
            font-size: 32px;
        }
    }
</style>
